import {
  AccountIssue,
  AccountIssueData,
  AccountIssueRepository,
  DatabaseService,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getAccountIssueRepository(
  databaseService: DatabaseService,
): AccountIssueRepository {
  return getGenericRepository<AccountIssue, AccountIssueData>(
    () => DatabaseCollection.ACCOUNT_ISSUES,
    databaseService,
  );
}
